'use client';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const SetCssVarClient: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.body.style.setProperty(
      '--entries-label',
      `"${t('pagging.elements').toLocaleLowerCase()}"`,
    );
  }, [t]);

  return null;
};

export default SetCssVarClient;
